export const odobrenjeAplikacijeTabs = [
  { value: "1", label: "Aplikacije za RAR" },
  { value: "2", label: "Aplikacije za eRAR" },
  { value: "3,7", label: "Aplikacije za OR1/eOR1" },
  { value: "4,8", label: "Aplikacije za OR2/eOR2" },
  { value: "5,9", label: "Aplikacije za OR3/eOR3" },
  { value: "6,10", label: "Aplikacije za OR4/eOR4" },
  { value: "11", label: "Aplikacije za TT" },
  { value: "12", label: "Aplikacije za TT" },
  { value: "13", label: "Aplikacije za TP1" },
  { value: "14", label: "Aplikacije za TP2" },
];

export const countOccurrences = (array) => {
  const countObject = {};
  array.forEach((id) => {
    countObject[id] = (countObject[id] || 0) + 1;
  });
  return countObject;
};
export const columnNames = (programName) => {
  console.log("Program", programName);
  let names = [];
  names = [
    "Ime i prezime",
    `${programName}`,
    `Evaluacija ${programName.includes("OR") ? "mentora" : "voditelja"}`,
    "Komentar",
  ];
  return names;
};

export const programGroups = {
  OR: [3, 4, 5, 6],
  eOR: [7, 8, 9, 10],
  TP1: [13],
  TP2: [14],
  TT: [11, 12],
};

export const getAllowedApplicationProgramIds = (groupProgramId) => {
  if (groupProgramId === 1) return programGroups.OR.map(String);
  if (groupProgramId === 2) return programGroups.eOR.map(String);
  if ([4, 5, 6].includes(groupProgramId)) return programGroups.TP1.map(String);
  if (groupProgramId === 13) return programGroups.TP2.map(String);
  if (groupProgramId === 14) return programGroups.TT.map(String);
  return [];
};
export const programIdToKeyMap = {
  3: "OR",
  7: "eOR",
  13: "TP1",
  14: "TP2",
  11: "TT",
};
